module.exports = __webpack_public_path__ + "img/imei-search.91400a9b.png";